import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Pos } from 'src/app/core/classes/pos';

@Component({
  selector: 'dq-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss'],
})
export class ActionBarComponent implements OnInit {
  @Output() edit = new EventEmitter<null>();
  @Output() validate = new EventEmitter<null>();
  @Output() cancel = new EventEmitter<null>();
  @Output() save = new EventEmitter<null>();

  @Input()
  editMode: boolean = false;

  @Input()
  showEdit: boolean = false;

  @Input()
  pos?: Pos;

  constructor() {}

  ngOnInit(): void {}

  riseEdit() {
    this.edit.emit();
    this.editMode = true;
  }

  riseValidate() {
    this.validate.emit();
  }

  riseSave() {
    this.save.emit();
    this.editMode = false;
  }

  riseCancel() {
    this.cancel.emit();
    this.editMode = false;
  }
  getCommercialName() {
    return this.pos != null ? this.pos.commercialName : '';
  }
  showID() {
    return this.pos != null && this.pos.origin == 'IND' ? true : false;
  }
  showDD() {
    return this.pos != null &&
      (this.pos.origin == null || this.pos.origin == '')
      ? true
      : false;
  }
}
